import { DetailSubsection } from '../DetailSubsection';
import React from 'react';
import { SuggestionButton } from '@ui/general/SuggestionButton';
import { SuggestTextEditor } from '@ui/text/SuggestTextEditor';
import { When } from 'react-if';
import { AutodocType, coreActions } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAction, useSonarObjectReference, useSuggestionEditor } from '@hooks';
export const BusinessContextDefinition = ({ autodocDisabled, sonarObjectId }) => {
    var _a, _b, _c;
    const definition = (_c = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.definition) !== null && _c !== void 0 ? _c : '';
    const autodocType = AutodocType.Definition;
    const updateSonarObjectContext = useAction(coreActions.requestPatchCoreSonarObjectsContext);
    const suggestion = useSuggestionEditor({
        autodocType,
        richText: true,
        sonarObjectId,
        value: definition
    });
    const handleSave = (content) => {
        updateSonarObjectContext({
            context: { definition: content },
            sonarObjectId
        });
    };
    const showSuggestButton = !autodocDisabled && !suggestion.isEditing && !suggestion.value && !suggestion.loading;
    return (React.createElement(DetailSubsection, { title: COPY_SPECIFIC.DEFINITION, titleExtra: React.createElement(When, { condition: showSuggestButton },
            React.createElement(SuggestionButton, { autodocType: autodocType, onClick: suggestion.request })) },
        React.createElement(SuggestTextEditor, { autodocType: autodocType, canBeEmpty: true, onSave: handleSave, placeholder: PLACEHOLDERS_COPY.ADD_A_BUSINESS_DEFINITION, sonarObjectId: sonarObjectId, suggestion: suggestion, value: definition !== null && definition !== void 0 ? definition : '' })));
};
